import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { GlgLoadingSpinner } from 'SharedComponents'
import { GlgCheckbox, GlgTooltipIcon, GlgTextInput } from 'src/shared/components/'
import { callAPI } from 'Shared/helpers'
import { getAuthenticityToken } from 'Shared/helpers'
import Toggle from 'react-bootstrap-toggle'

const StyledPage = styled.div`
  .spinner {
    padding-top: 10px;
  }

  .settings_container {
    display: flex;
    padding: 20px;

    .description {
      width: 25%;
      padding-right: 80px;

      .sub_title {
        font-weight: bold;
        padding-bottom: 10px;
      }
    }
    .list_of_checkboxes {
      display: flex;
      flex-direction: column;

      .check {
        display: flex;

        .icon_div {
          display: flex;
          align-items: center;
          padding-bottom: 4px;
        }
      }

      .set_selected {
        label {
          font-weight: bold;
        }
      }

      .not_clickable {
        pointer-events: none;
      }
    }

    .text_setting_container {
      display: flex;
      align-items: center;

      .text_setting_label {
        width: 140px;
        margin-right: 20px;
      }

      .google_tag_id_input {
        width: 230px;
      }

      .coach_now_url_input, .operation_36_url_input {
        width: 390px;
      }

      .text_setting_error_msg {
        color: red;
      }
    }

    .dropdown_setting_container {
      display: flex;
      align-items: center;

      .course_dropdown {
        width: 390px;
      }
    }

    .published-toggle {
      .btn {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

  }

  .settings_container:not(:first-child) {
    border-top: 1px dashed #DBDBDB;
  }
`

const GolfHubCustomerSettings = (props) => {
  const [ dataIsLoading, setDataIsLoading ] = useState(true)
  const [ settings, setSettings ] = useState({})
  const [ savingSettings, setSavingSettings ] = useState(false)
  const [ errors, setErrors ] = useState({})

  useEffect(() => {
    callAPI(`/customers/${props.customerId}/golf_hub_customer_settings`, 'GET')
    .then((json) => {
      setSettings(json)
      setDataIsLoading(false)
    })
  }, [])

  const saveFormData = () => {
    const fd = new FormData()
    
    fd.append('my_hubs', settings['golfhub_page_visibility_my_hubs'])
    fd.append('agg_hubs', settings['golfhub_page_visibility_aggregated_hubs'])
    fd.append('customer_parents', JSON.stringify(settings['customer_parents'] || []))
    fd.append('google_tag_id', settings['google_tag_id'] || '')
    fd.append('course_id', settings['course_id'] || '')
    fd.append('coach_now_url', settings['coach_now_url'] || '')
    fd.append('operation_36_url', settings['operation_36_url'] || '')
    fd.append('display_registered_golfers', settings['display_registered_golfers'])

    setSavingSettings(true)
    fetch(`/customers/${props.customerId}/golf_hub_customer_settings/${settings['settings_id']}`, {
      method: 'PATCH',
      body: fd,
      headers: {
        'X-CSRF-Token': getAuthenticityToken(),
      },
    })
    .then((response) => {
      if (response.ok) {
        setSavingSettings(false)
        window.show_flash(!window.I18n ? '' : window.I18n.t('views.golfhub.errors.settings.good_save'))
        window.hide_flash()
      } else {
        setSavingSettings(false)
        window.show_flash(!window.I18n ? '' : window.I18n.t('views.golfhub.errors.settings.bad_save'))
        window.hide_flash()
      }
    })
  }

  const updateParentIncludeSetting = (parentId) => {
    const updatedSetting = { ...settings }

    updatedSetting.customer_parents = updatedSetting.customer_parents.map((parent) => {
      if (parent.id === parentId) {
        return {
          ...parent,
          is_included_in_parent_hub: !parent.is_included_in_parent_hub,
        }
      }

      return parent
    })

    setSettings(updatedSetting)
  }

  useEffect(() => {
    const formErrors = {}

    if (settings['coach_now_url'] && !settings['coach_now_url'].match('^https:\/\/app\.coachnow\.io\/public\/')) {
      formErrors['coach_now_url'] = !window.I18n ? '' : window.I18n.t('views.golfhub.errors.coach_now_url')
    }
    if (settings['operation_36_url'] && !settings['operation_36_url'].match('^https://operation36golf.com/landing/[0-9]+$')) {
      formErrors['operation_36_url'] = !window.I18n ? '' : window.I18n.t('views.golfhub.errors.operation_36_url')
    }

    setErrors(formErrors)
  }, [settings['coach_now_url'], settings['operation_36_url']])

  return (
    <StyledPage>
      {dataIsLoading && (
        <GlgLoadingSpinner className='spinner text-center' show={dataIsLoading} />
      )}
      {!dataIsLoading && (
        <div className="gh_customer_settings_tab">
          <div className="settings_container">
            <div className="description">
              <div className="sub_title">
                { !window.I18n ? '' : window.I18n.t('views.golfhub.visibility_setting') }
              </div>
              <div className="long_desc">
                { !window.I18n ? '' : window.I18n.t('views.golfhub.visibility_desc_setting') }
              </div>
            </div>
            <div className="list_of_checkboxes">
              <div className={`check my_hubs ${settings['golfhub_page_visibility_my_hubs'] ? 'set_selected' : ''}`}
                  onClick={() => setSettings({...settings, golfhub_page_visibility_my_hubs: !settings['golfhub_page_visibility_my_hubs']})}>
                <div className="not_clickable">
                  <GlgCheckbox
                    name="golfhub_page_visibility_my_hubs"
                    label={ !window.I18n ? '' : window.I18n.t('views.golfhub.my_hubs') }
                    checked={ settings['golfhub_page_visibility_my_hubs'] }
                  />
                </div>
                <div className="icon_div">
                  <GlgTooltipIcon
                    tooltip = { !window.I18n ? '' : window.I18n.t('views.golfhub.my_hubs_tooltip') }
                  />
                </div>
              </div>
              {settings['customer_parents'] !== undefined && settings['customer_parents'].length > 0 && settings['customer_parents'].map((setting) => {
                return (
                  <div className={`check parent_checkbox ${setting['is_included_in_parent_hub'] ? 'set_selected' : ''} ${setting['is_parent_active'] ? '' : 'hidden'}`} 
                      key={setting['id']}
                      onClick={() => updateParentIncludeSetting(setting['id'])}>
                    <div className="not_clickable">
                      <GlgCheckbox
                        name={ setting['name'] }
                        label={ setting['name'] + ' ' + (!window.I18n ? '' : window.I18n.t('views.golfhub.hubs')) }
                        checked={ setting['is_included_in_parent_hub'] }
                      />
                    </div>
                    <div className="icon_div">
                      <GlgTooltipIcon
                        tooltip = { !window.I18n ? '' : window.I18n.t('views.golfhub.parent_hubs_tooltip', {parent: setting['name']}) }
                      />
                    </div>
                  </div>
                )
              })}
              <div className={`check agg_hubs ${settings['golfhub_page_visibility_aggregated_hubs'] ? 'set_selected' : ''}`} 
                  onClick={() => setSettings({...settings, golfhub_page_visibility_aggregated_hubs: !settings['golfhub_page_visibility_aggregated_hubs']})}>
                <div className="not_clickable">
                  <GlgCheckbox
                    name="golfhub_page_visibility_aggregated_hubs"
                    label={ (!window.I18n ? '' : window.I18n.t('product')) + ' ' + (!window.I18n ? '' : window.I18n.t('views.golfhub.hubs')) }
                    checked={ settings['golfhub_page_visibility_aggregated_hubs'] }
                  />
                </div>
                <div className="icon_div">
                  <GlgTooltipIcon
                    tooltip = { !window.I18n ? '' : window.I18n.t('views.golfhub.golf_genius_hubs_tooltip') }
                  />
                </div>
              </div>
            </div>
          </div>

          <div className='settings_container'>
            <div className="description">
              <div className="sub_title">
              { !window.I18n ? '' : window.I18n.t('views.golfhub.google_tag_id') }
              </div>
            </div>
            <div className='text_setting_container'>
              <div className='google_tag_id_input'>
                <GlgTextInput
                  placeholder={'GTM-XXXXXX / G-XXXXXXXXX'}
                  value={settings['google_tag_id'] || ''}
                  onChange={(googleTagId) => setSettings({...settings, google_tag_id: googleTagId})}
                />
              </div>
            </div>
          </div>

          <div className='settings_container'>
            <div className='description'>
              <div className='sub_title'>
                { !window.I18n ? '' : window.I18n.t('views.golfhub.course') }
              </div>
              <div className='long_desc'>
                { !window.I18n ? '' : window.I18n.t('views.golfhub.course_description') }
              </div>
            </div>
            <div className='dropdown_setting_container'>
              <div className='course_dropdown'>
                {(settings['courses'].length > 0 &&
                  <select className='form-control' onChange={ (e) => setSettings({...settings, course_id: e.target.value}) } defaultValue={settings['course_id'] || ''}>
                    {
                      settings['courses'].map( course => <option key={ course.id } value={ course.id }>{ course.name }</option> )
                    }
                  </select>
                )}
              </div>
            </div>
          </div>

          <div className={`settings_container ${(settings['course_id'] != null && settings['course_id'] !== '') ? '' : 'hidden'}`}>
            <div className='description'>
              <div className='sub_title'>
                { !window.I18n ? '' : window.I18n.t('views.golfhub.coach_now_link') }
              </div>
              <div className='long_desc'>
                { !window.I18n ? '' : window.I18n.t('views.golfhub.coach_now_description') }
              </div>
            </div>
            <div className='text_setting_container'>
              <div className='coach_now_url_input'>
                <input
                  defaultValue={settings['coach_now_url'] || ''}
                  onChange={(e) => setSettings({...settings, coach_now_url: e.target.value})}
                  type='url'
                  className={`form-control ${errors['coach_now_url'] && 'is_field_error'}`}
                  placeholder='https://app.coachnow.io/public/'
                />
                <span className='text_setting_error_msg'>{errors['coach_now_url']}</span>
              </div>
            </div>
          </div>

          <div className={`settings_container ${(settings['course_id'] != null && settings['course_id'] !== '') ? '' : 'hidden'}`}>
            <div className='description'>
              <div className='sub_title'>
                { !window.I18n ? '' : window.I18n.t('views.golfhub.operation_36_link') }
              </div>
              <div className='long_desc'>
                { !window.I18n ? '' : window.I18n.t('views.golfhub.operation_36_description') }
              </div>
            </div>
            <div className='text_setting_container'>
              <div className='operation_36_url_input'>
                <input
                  defaultValue={settings['operation_36_url'] || ''}
                  onChange={(e) => setSettings({...settings, operation_36_url: e.target.value})}
                  type='url'
                  className={`form-control ${errors['operation_36_url'] && 'is_field_error'}`}
                  placeholder='https://operation36golf.com/landing/'
                />
                <span className='text_setting_error_msg'>{errors['operation_36_url']}</span>
              </div>
            </div>
          </div>

          <div className="settings_container">
            <div className="description">
              <div className="sub_title">
                { !window.I18n ? '' : window.I18n.t('views.golfhub.display_registered_golfers') }
              </div>
              <div className='long_desc'>
                { !window.I18n ? '' : window.I18n.t('views.golfhub.display_registered_golfers_tooltip') }
              </div>
            </div>
            <div className="display_registered_golfers">
              <Toggle onClick={ () => { setSettings({...settings, display_registered_golfers: !settings['display_registered_golfers']}) } }
                on={ !window.I18n ? '' : window.I18n.t('views.golfhub.affirmative_answer') }
                off={ !window.I18n ? '' : window.I18n.t('views.golfhub.negative_answer') }
                className='rounded published-toggle'
                active={!settings['display_registered_golfers']}
                id='toggle-display_registered_golfers'
              />
            </div>
          </div>

          <div className='save_bar'>
            <a className='button btsp_gray_button' onClick={() => {
              window.location.pathname = `/customers/${props.customerId}/hubs`
            }}>{!window.I18n ? '' : window.I18n.t('views.golfhub.cancel')}</a>
            <a className='button btsp_orange_button' disabled={errors['coach_now_url'] || errors['operation_36_url'] || savingSettings} onClick={() => {
              if (Object.keys(errors).length === 0) {
                saveFormData()
              }
            }}>{savingSettings ? (!window.I18n ? '' : window.I18n.t('views.golfhub.saving')) : (!window.I18n ? '' : window.I18n.t('views.golfhub.modal.save'))}</a>
          </div>
        </div>
      )}
    </StyledPage>
  )
}

GolfHubCustomerSettings.propTypes = {
  customerId: PropTypes.string,
}

export default GolfHubCustomerSettings
